import { useQuery } from '@tanstack/react-query'
import { api } from '../../api/client'
import type { DeskConversationPage } from '../../lib/supportDesk'

/** One page of GET /api/support/conversations; every desk list shares this query key. `poll` refetches every 60s,
 *  matching the summary's cadence, so a workspace queue agrees with the polled menu counts. */
export function useConversationPage(params: URLSearchParams, { poll = false }: { poll?: boolean } = {}) {
  return useQuery<DeskConversationPage>({
    queryKey: ['support', 'conversations', params.toString()],
    queryFn: () => api.get<DeskConversationPage>(`/api/support/conversations?${params}`),
    retry: false,
    refetchInterval: poll ? (q) => (q.state.status === 'error' ? false : 60_000) : false,
  })
}
